// extracted by mini-css-extract-plugin
export var copyableField = "_lh-4";
export var customerBadge = "_lh-0";
export var customerInfoTitle = "_lh-2";
export var details = "_lh-1";
export var dropdownContainer = "_lh-5";
export var dropdownImage = "_lh-6";
export var editAssigneeForm = "_lh-a";
export var editButton = "_lh-3";
export var email = "_lh-7";
export var hidden = "_lh-d";
export var input = "_lh-8";
export var saveButton = "_lh-b";
export var shopifyIcon = "_lh-c";
export var suggestionBadge = "_lh-e";
export var suggestionText = "_lh-f";
export var username = "_lh-9";